import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TravelService } from 'src/app/services/travel.service';
import { Travel } from '../../../models/travel';
import { CommercialDocument } from '../../../models/commercial-document';
import { UtilitiesService } from '../../../services/utilities.service';
import { CommercialDocumentService } from '../../../services/commercial-document.service';
import { CommercialDocumentsFormComponent } from '../commercial-documents/commercial-documents-form/commercial-documents-form.component';

@Component({
  selector: 'app-internal-travel-documents',
  templateUrl: './internal-travel-documents.component.html',
  styleUrls: ['./internal-travel-documents.component.css']
})
export class InternalTravelDocumentsComponent implements OnInit {

  loading: boolean = false;
  internalTravel: Travel = null;
  travelInternalId: number = null;
  foundTravel: boolean = true;
  search: boolean = false;
  cdlist: CommercialDocument[] = [];
  newDocument: boolean = true;
  canCreateDocument: boolean = true;
  //@ViewChild(CommercialDocumentsFormComponent) child;

  constructor(private travelService: TravelService, private toast: ToastrManager, private utl: UtilitiesService) { }

  ngOnInit() {}

  searches(){
    this.loading = true;
    if(this.travelInternalId){
      this.travelService.getInternalTravelByID(this.travelInternalId).subscribe( response => {
        this.search = true; //Se activa cuando se realiza una busqueda
        if(response.id){
          this.internalTravel = response;
          this.loading = false;
        }else{ 
          this.foundTravel = false;
          this.loading = false;
        }
      }, error => {
        this.loading = false;
        this.toast.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      });
    }else{
      this.loading = false;
      this.toast.infoToastr('Debes ingresar un ID del viaje para realizar la busqueda', '', {enableHTML: true});
    }
  }

  store(message){
    this.setDefaultData();
    this.toast.successToastr(message, '', {enableHTML: true});
  }

  setDefaultData(){
    this.internalTravel = null;
    this.travelInternalId = null;
    this.foundTravel = true;
    this.search = false;
    this.canCreateDocument = true;
  }

  updateCanCreateDocument(doc: boolean){
    this.canCreateDocument = doc;
  }
}
